import { ThemeVariant } from 'mobx/storeTypes';
import { constructTheme } from 'utils/constructTheme';

export const useCurrentTheme = () => {
  const currentTheme = constructTheme(ThemeVariant.DARK);

  return currentTheme;
};
